export default "__VITE_ASSET__3ddf0c05__"